import React, { useState,useEffect } from "react";
import { Link } from 'react-router-dom';
import amaxLogo from "../../images/amaxLogo.png";
import API_URL from '../../api/API';

export const CoachForgotPassword = () => {
  const [email,setEmail] = useState('');
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!email) {
      setError('Please enter the email.');
      return;
    }

    setError(null);
    setMsg(null);
    setLoading(true);

  try {
      const response = await fetch(API_URL.POST_COACH_FORGOT_PASSWORD, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({email}),
      });

      const json = await response.json();
      setLoading(false);

      if (response.ok) {
          setMsg(json.message);
          setEmail('');
      } 
      else 
      {
        // Display error returned by the server
        setError(json.error || 'An error occurred. Please try again.');
      }
    } catch (err) {
      setLoading(false);
      setError('Failed to connect to the server. Please try again.');
    }
  };
 


  return (
    <div className="p-[20px] bg-black h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
            <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>
        <div className="w-full flex flex-col gap-8">
          <div className="flex flex-col gap-[15px]">
            <p className="text-white text-[26px] leading-[108%] font-normal">
              Forgot Password <br />
              <span className="font-bold text-[40px] leading-[95%]">
                COACH.
              </span>
            </p>

                  {/* Display Loading Indicator */}
                  {loading && (
                <p className="text-yellow-500 text-sm mt-2">
                  Processing request please wait...
                </p>
              )}

                 {/* Display Success Message */}
                 {msg && (
                <p className="text-green-500 text-sm mt-2">
                  {msg}
                </p>
              )}

                {/* Display Error Message */}
             {error && (
                  <p className="text-red-500 text-sm mt-2">
                    {error}
                  </p>
                )}


            <form action="" className="flex flex-col gap-[15px]">
              <input
                type="email"
                className="border border-white rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="Email*"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </form>
           
              <button  onClick={handleSubmit} className="text-base font-semibold w-full bg-white transition-all duration-300 rounded-[75px] border border-white flex justify-center items-center px-2 py-[18px] hover:text-white hover:bg-transparent">
                RETRIVE PASSWORD
              </button>
           
            <Link
              to="/coach/login"
              className="text-white hover:text-[#5d5d5d] transition-all duration-300 text-sm font-normal text-end inline-block w-fit ml-auto"
            >
              Login
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};
